import { CircleIconButton } from './CircleIconLink'
import { clipboardCopy } from '@/util/clipboardCopy'
import Dropdown from './Dropdown'
import { ContextualMenuProps } from './ContextualMenu/types'

interface Props {
  className?: string
  circleIconButtonClassName?: string
  contextualMenuConfig?: Partial<ContextualMenuProps>
  TriggerComponent?: (props: {
    onClick: () => void
    className?: string
  }) => React.ReactNode
}

export default function SocialShareMenu({
  className = '',
  circleIconButtonClassName = '',
  contextualMenuConfig = {},
  TriggerComponent = props => <DefaultTriggerComponent {...props} />
}: Props) {
  return (
    <Dropdown
      className={className}
      Trigger={props =>
        TriggerComponent({
          onClick: props.onClick,
          className: circleIconButtonClassName
        })
      }
      appearance={contextualMenuConfig?.appearance}
      items={[
        {
          label: 'Copy Link',
          iconName: 'link',
          onClick: async () => await clipboardCopy(location.href)
        },
        {
          label: 'Share on Facebook',
          iconName: 'facebook',
          onClick: () =>
            window.open(
              `https://www.facebook.com/sharer/sharer.php?u=${location.href}`,
              '_blank'
            )
        },
        {
          label: 'Share on X',
          iconName: 'twitter',
          onClick: () =>
            window.open(
              `https://twitter.com/intent/tweet?url=${location.href}"`,
              '_blank'
            )
        }
      ]}
    />
  )
}

const DefaultTriggerComponent = ({
  onClick,
  className
}: {
  onClick: () => void
  className?: string
}) => {
  return (
    <CircleIconButton
      name="share"
      onClick={onClick}
      className={className}
      iconClassName="-translate-x-[1.2px]"
    />
  )
}
